export const MULTIPLE_CHOICE = "multiple_choice";
export const MULTIPLE_CHOICE_NO_ANSWER = "multiple_choice_no_answer";
export const CHECKBOX_VARIANT = "checkbox";

export function isMultipleChoiceLike(questionType: string | undefined | null): boolean {
  return questionType === MULTIPLE_CHOICE || questionType === MULTIPLE_CHOICE_NO_ANSWER;
}

/**
 * Detect a checkbox-style question (multi-select).
 * Stored as question_type=multiple_choice_no_answer + answer_type=checkbox / ui_variant=checkbox.
 */
export function isCheckboxQuestion(
  q:
    | {
        question_type?: string | null;
        answer_type?: string | null;
        ui_variant?: string | null;
      }
    | null
    | undefined,
): boolean {
  if (!q) return false;
  if (String(q.ui_variant || "").toLowerCase() === CHECKBOX_VARIANT) return true;
  if (String(q.answer_type || "").toLowerCase() === CHECKBOX_VARIANT) return true;
  return false;
}
